import React, { Component } from 'react';
import { ButtonToolbar, Button, Grid, Row, Col, Label, Table } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import { ExportForm } from './ExportForm';
import { EditionSelector } from '../../EditionSelector';
import { TitleRow } from '../../TitleRow';
import { LoadingSpinner } from '../../LoadingSpinner';
import { SearchBar } from '../../SearchBar';
import { SearchHelper } from '../../helpers/SearchHelper';
import { TableButton } from '../../TableButton';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { PaginationBuilder } from '../../PaginationBuilder';
import { HandleMessage } from '../../HandleMessage';

import { DownloadCommand } from '../../files/commands/DownloadCommand';
import { LinesCommand } from '../commands/LinesCommand';
import { StopsCommand } from '../commands/StopsCommand';
import { SchedulesCommand } from '../commands/SchedulesCommand';
import { TripsCommand } from '../commands/TripsCommand';
import { ExportCommand } from '../commands/ExportCommand';

import ColumnResize from "react-table-column-resizer";

export class Export extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func,
        setShowMetadataButton: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            commands: {
                lines: new LinesCommand(),
                stops: new StopsCommand(),
                schedules: new SchedulesCommand(),
                trips: new TripsCommand(),
                export: new ExportCommand(),
                download: new DownloadCommand(),
            },
            count: {
                lines: 0,
                stops: 0,
                schedules: 0,
                trips: 0
            },
            documents: {
                data: [],
                page: 1,
                elementsPerPage: 50,
                filter: ""
            },
            form: {
                model: undefined
            },
            actions: {
                isLoadingEdition: false,
                isExporting: false,
                isLoadingDocuments: true,
                isLoadingLines: true,
                isLoadingStops: true,
                isLoadingTrips: true,
                isLoadingSchedules: true
            },
            message: {
                title: "",
                message: undefined,
                style: undefined,
                icon: undefined,
                show: false
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        this.context.addEditionObserver(this);

        this.getExportedDocuments();
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = false;

        this.setState({
            actions: actions
        });
    }

    updateNetwork() {
        const { actions } = this.state;

        actions.isLoadingLines = true;
        actions.isLoadingStops = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.countActiveNetwork(edition);
        });
    }

    updatePlanning() {
        const { actions } = this.state;

        actions.isLoadingTrips = true;
        actions.isLoadingSchedules = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.countActivePlanning(edition);
        });
    }

    // ----------------------

    getExportedDocuments(resetData = false) {
        if (resetData) {
            const { actions, documents } = this.state;

            documents.data = [];
            actions.isLoading = true;

            this.setState({
                documents: documents,
                actions: actions
            });
        }

        const { selectedProvider } = this.context;
        const { commands, actions } = this.state;

        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        actions.isLoadingDocuments = true;
        commands.export.getAll(
            selectedProviderId,
            (a) => this.listSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    countActiveNetwork(edition) {
        const { selectedProvider } = this.context;
        const { commands, actions } = this.state;

        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        // Lines
        actions.isLoadingLines = true;
        commands.lines.count(
            edition,
            selectedProviderId,
            (a) => this.countSuccessCallback(a, "lines", "isLoadingLines"),
            (a) => this.countErrorCallback(a, "lines", "isLoadingLines")
        );

        // Stops
        actions.isLoadingStops = true;
        commands.stops.count(
            edition,
            selectedProviderId,
            (a) => this.countSuccessCallback(a, "stops", "isLoadingStops"),
            (a) => this.countErrorCallback(a, "stops", "isLoadingStops")
        );

        this.setState({
            actions: actions
        });
    }

    countActivePlanning(edition) {
        const { selectedProvider } = this.context;
        const { commands, actions } = this.state;

        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        //Schedules
        actions.isLoadingSchedules = true;
        commands.schedules.count(
            edition,
            selectedProviderId,
            (a) => this.countSuccessCallback(a, "schedules", "isLoadingSchedules"),
            (a) => this.countErrorCallback(a, "schedules", "isLoadingSchedules")
        );

        //Trips
        actions.isLoadingTrips = true;
        commands.trips.count(
            edition,
            selectedProviderId,
            (a) => this.countSuccessCallback(a, "trips", "isLoadingTrips"),
            (a) => this.countErrorCallback(a, "trips", "isLoadingTrips")
        );

        this.setState({
            actions: actions
        });
    }

    // ---------------------------

    listSuccessCallback(result) {
        const { documents, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, documents.elementsPerPage);

        actions.isLoadingDocuments = false;
        documents.data = result;
        if (0 !== totalPages) {
            documents.page = documents.page > totalPages ? totalPages : documents.page;
        }
        else {
            documents.page = 1;
        }

        // Update table
        this.setState({
            documents: documents,
            actions: actions
        });
    }

    listErrorCallback(messageReceived) {
        const { documents, actions, message } = this.state;

        actions.isLoadingDocuments = false;
        documents.data = [];
        documents.page = 1;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            documents: documents,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    countSuccessCallback(result, target, action) {
        const { count, actions } = this.state;

        count[target] = result.count;
        actions[action] = false;

        // Update table
        this.setState({
            count: count,
            actions: actions
        });
    }

    countErrorCallback(messageReceived, target, action) {
        const { count, actions, message } = this.state;

        count[target] = 0;
        actions[action] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            count: count,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getExportedDocuments(true);
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    downloadSuccessCallback(blob, format) {
        var FileSaver = require('file-saver');
        FileSaver.saveAs(blob, format);
    }

    downloadErrorCallback(messageReceived) {
        const { message } = this.state;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        })
    }

    // ---------------------------

    onChangeFormModel(model) {
        const { form } = this.state;

        form.model = model;

        this.setState({
            form: form
        });
    }

    onExport() {
        const { selectedProvider } = this.context;
        const { commands, form, actions } = this.state;

        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        actions.isExporting = true;
        commands.export.export(
            form.model,
            selectedProviderId,
            (a) => this.operationSuccessCallback(a, "isExporting"),
            (a) => this.operationErrorCallback(a, "isExporting")
        );

        this.setState({
            actions: actions
        });
    }

    startDownload(name) {
        const { selectedProvider } = this.context;
        const { commands } = this.state;

        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        commands.download.downloadExportedDocument(name, selectedProviderId,
            (a) => this.downloadSuccessCallback(a, name),
            (a) => this.downloadErrorCallback(a)
        );
    }

    // ---------------------------

    onExitMessage() {
        this.setState({
            message: {
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                show: false
            }
        });
    }

    onChangePage(page) {
        const { documents } = this.state;

        documents.page = page;

        this.setState({
            documents: documents
        });
    }

    onChangeElementsPerPage(elements) {
        const { documents } = this.state;

        documents.elementsPerPage = elements;

        this.setState({
            documents: documents
        });
    }

    onSearch(filter) {
        const { documents } = this.state;

        documents.filter = filter;

        this.setState({
            documents: documents
        });
    }

    formattedDate(date) {
        if (date !== null && date !== undefined) {
            var aux = date.substring(0, 10)
            var newString = aux.split("-")
            var finalString = ""
            for (var i = newString.length - 1; i >= 0; i--) {
                finalString += newString[i] + '-';
            }

            return finalString.substring(0, 10);
        }

        return "";
    }

    // ---------------------------

    renderForm() {
        return (
            <ExportForm onChangeFormModel={(a) => this.onChangeFormModel(a)} />
        );
    }

    renderDownloadLink(link) {
        if (undefined === link || null === link || "" === link) {
            return null;
        }

        return (
            <TableButton
                icon="icon-download"
                onClick={() => this.startDownload(link)}
                title="Transferir"
            />
        );
    }

    renderActiveNetworkInfo(actions) {
        if (actions.isLoadingLines || actions.isLoadingStops || actions.isLoadingSchedules || actions.isLoadingTrips) {
            return <LoadingSpinner />
        }

        const { count } = this.state;

        return (
            <Grid fluid className="margin-top-15">
                <Row>
                    <Col sm={6}>
                        <Label className="panel-labels panel-label-title margin-top-10">LINHAS</Label>
                        <Label className="panel-labels panel-label-data"><span>{count.lines}</span></Label>
                    </Col>

                    <Col sm={6}>
                        <Label className="panel-labels panel-label-title margin-top-10">PARAGENS</Label>
                        <Label className="panel-labels panel-label-data"><span>{count.stops}</span></Label>
                    </Col>
                </Row>

                <Row>
                    <Col sm={6}>
                        <Label className="panel-labels panel-label-title margin-top-10">HORÁRIOS</Label>
                        <Label className="panel-labels panel-label-data"><span>{count.schedules}</span></Label>
                    </Col>

                    <Col sm={6}>
                        <Label className="panel-labels panel-label-title margin-top-10">VIAGENS</Label>
                        <Label className="panel-labels panel-label-data"><span>{count.trips}</span></Label>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderExportedDocs(actions) {
        if (actions.isLoadingDocuments) {
            return <LoadingSpinner />
        }

        const { documents } = this.state;

        const documentsFilter = SearchHelper.search({
            filter: documents.filter,
            data: documents.data,
            fields: ["name", "generationDate"],
            callbackComparison: [{ "generationDate": (a) => this.formattedDate(a) }]
        });

        const totalPages = PaginationHelper.getTotalPages(documentsFilter.length, documents.elementsPerPage);
        const activePage = totalPages < this.state.currentPage ? totalPages : documents.page;
        const documentsToRender = documentsFilter.sort((a, b) => a.generationDate !== b.generationDate ? a.generationDate > b.generationDate ? -1 : 1 : 0)
            .slice((activePage - 1) * documents.elementsPerPage, activePage * documents.elementsPerPage);

        return (
            <Grid fluid className="margin-top-15">
                <Table responsive striped hover >
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <ColumnResize className="columnResizer" />
                            <th>Data de Criação</th>
                            <ColumnResize className="columnResizer" />
                            <th>Guardar</th>
                            <ColumnResize className="columnResizer" />
                        </tr>
                    </thead>
                    <tbody>
                        {
                            documentsToRender.map((doc, idx) =>
                                <tr key={`doc-${idx}`}>
                                    <td>{undefined !== doc.name ? doc.name : ''}</td>
                                    <td className="column_resizer_body" />
                                    <td>{this.formattedDate(doc.generationDate)}</td>
                                    <td className="column_resizer_body" />
                                    <td>{this.renderDownloadLink(doc.name)}</td>
                                    <td className="column_resizer_body" />
                                </tr>
                            )
                        }
                    </tbody>
                </Table>

                <PaginationBuilder
                    currentPage={documents.page}
                    elementsPerPage={documents.elementsPerPage}
                    dataLength={documentsFilter.length}
                    onChangePage={(a) => this.onChangePage(a)}
                    onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />

            </Grid>
        );
    }

    render() {
        const { actions, message } = this.state;

        return (
            <div>
                <EditionSelector />

                <div>
                    <TitleRow title="Exportação de Dados" showSeparator={true}>
                        <ButtonToolbar className="pull-right">
                            <Button onClick={() => this.onExport()}>Exportar</Button>
                        </ButtonToolbar>
                    </TitleRow>
                </div>

                <div>
                    {this.renderForm()}
                </div>

                <div className="margin-top-50">
                    <TitleRow title="Dados da Rede Ativa" showSeparator={true}>
                    </TitleRow>

                    {this.renderActiveNetworkInfo(actions)}
                </div>

                <div className="margin-top-50">
                    <TitleRow title="Documentos" showSeparator={true}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </TitleRow>

                    {this.renderExportedDocs(actions)}
                </div>

                <HandleMessage
                    title="A Exportar Rede Ativa..."
                    message={<LoadingSpinner />}
                    style={`primary`}
                    icon="transfer"
                    show={actions.isExporting}
                    small
                    noButtons />

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleMessage
                    title="A Carregar a Edição..."
                    message={<LoadingSpinner />}
                    style={`primary`}
                    icon="transfer"
                    show={actions.isLoadingEdition}
                    small
                    noButtons />
            </div>
        );
    }
}
